import apiClient from './apiClient';

export const createContract = async (title, pages) => {
  try {
    const response = await apiClient.post('/contracts', { title, pages });
    return response.data;
  } catch (error) {
    console.error('Error creating contract:', error);
    throw error;
  }
};

export const deleteContract = async (emailId) => {
  try {
    await apiClient.delete(`/contracts/${emailId}`);
  } catch (error) {
    throw new Error(`Failed to delete contract with ID ${emailId}: ${error.message}`);
  }
};
